var map = {
	"./Ahmed-El-Kholy.png": 2494,
	"./ApoloP2PImage.png": 1823,
	"./ArrowDown.jpg": 8508,
	"./ArrowUp.jpg": 7559,
	"./AshleyAsin.png": 9900,
	"./BGHomePage.jpg": 9198,
	"./CategoryBasics.png": 7846,
	"./CategoryBlockchain.png": 597,
	"./CategoryBlockchainDev.png": 9824,
	"./CategoryDAO.png": 6931,
	"./CategoryDeFi.png": 9069,
	"./CategoryMetaverse.png": 1541,
	"./CategoryNFT.png": 5603,
	"./CategorySmartContracts.png": 1431,
	"./CategoryTrading.png": 608,
	"./EnriqueBarba.jpg": 7184,
	"./EnriqueBarba.png": 6340,
	"./FooterGirl.png": 3184,
	"./FooterMan.png": 3940,
	"./JoanArrey.png": 6736,
	"./LogoWhite.png": 5531,
	"./MarkMoores.png": 3023,
	"./OLU-FRANCIS DANIEL.HEIC": 712,
	"./Section2.png": 6318,
	"./Section2Popup1.png": 1469,
	"./Section2Popup2.png": 9846,
	"./Section2Popup3.png": 6175,
	"./Section3.png": 5543,
	"./Section3Popup1.png": 3420,
	"./Section3Popup2.png": 9831,
	"./Section3Popup3.png": 1518,
	"./Section4Blockchain.png": 7834,
	"./Section4Crypto.png": 8983,
	"./Section4DAO.png": 9510,
	"./Section4DeFi.png": 6746,
	"./Section4Metaverse.png": 1040,
	"./Section4NFT.png": 3294,
	"./Section4SmartContracts.png": 4524,
	"./Section4Trading.png": 1689,
	"./Section5Icon1.png": 2633,
	"./Section5Icon2.png": 1922,
	"./Section5Icon3.png": 6139,
	"./Section5Icon4.png": 4484,
	"./Section5Icon5.png": 4429,
	"./Section5OrangeBalls.png": 8789,
	"./Section6Feature1.png": 7061,
	"./Section6Feature2.png": 8929,
	"./Section6Feature3.png": 8999,
	"./Section6Feature4.png": 7480,
	"./Section6Feature5.png": 7425,
	"./Section6Feature6.png": 9114,
	"./Section7Support1.png": 8917,
	"./Section7Support2.png": 8542,
	"./Section7Support3.png": 4327,
	"./Section8Image1.png": 9880,
	"./ToolChartAnalysis.png": 1751,
	"./ToolClassRecording.png": 5296,
	"./ToolCodeEditor.png": 7077,
	"./ToolDocumentEditor.png": 9829,
	"./ToolVectorialDesign.png": 4526,
	"./ToolVideoConference.png": 6374,
	"./ToolWebBrowser.png": 727,
	"./ToolWhiteboard.png": 7588,
	"./VICTORIA RUSCICA .jpg": 384,
	"./genet-hagos.png": 1283,
	"./hassan.png": 4021,
	"./konstantinos-chonas-vastardos.jpg": 1977,
	"./morris-menanya.jpg": 6235,
	"./morrisMenanya.jpg": 5320,
	"./morrisMenanya2.jpg": 5872,
	"./serena-bohannon.jpg": 9257,
	"./shumet-worku.jpg": 8660,
	"./shumet-worku.png": 4112,
	"./vivian.png": 8522,
	"./vlad.png": 8358
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;